<template>
  <div class="map-wrap">

    <GmapMap
	  :center="{ lat: lat, lng: long }"
      :zoom="zoom"
      ref="map"
      :options="mapOptions"
      @center_changed="updateCenter($event)"
		>
        <GmapMarker
          :key="index"
          v-for="(marker, index) in markers"
          :position="marker.position"
          :clickable="true"
          :draggable="false"
          :label="marker.label"
          :icon="getMarkers(index)"
          @click="openInfoWindow(marker.position.id, index)"
        />
	  </GmapMap>

    <div class="info-window" v-if="infoWindow.open" >
      <div class="text">

        <button
          class="close-popup"
          @click="closeInfoWindow"
        >
          <span class="icon icon-cross"></span>
        </button>

        <h4>{{ infoWindow.title }}</h4>
        <a
          v-if="infoWindow.address"
          :href="'http://maps.google.com/?q='+infoWindow.address+'&output=classic'"
          target="_blank"
          class="address"
        >
          {{ infoWindow.address }}
        </a>
        <a :href="'tel:' + infoWindow.phone">{{ infoWindow.phone }}</a>
        <a :href="'mailto:' + infoWindow.email">{{ infoWindow.email }}</a>
        <a v-if="infoWindow.website" :href="infoWindow.website" class="orange" target="_blank">View website</a>

      </div>
    </div>

  </div>
</template>

<script>
  import { loadGmapApi, gmapApi } from "vue2-google-maps";
  export default {
    props: {
      mapmarkers: Array,
      locations: Array,
      latitude: Number,
      longitude: Number,
      zoomdata: Number,
      maps_api_key: String,
    },

    data () {
	  return {
        selectedKey: null,
		    markers: [],
        lat: null,
        long: null,
        zoom: 4,
        clusterStyles: [
          {
            url: '/images/cluster.png',
            height: 53,
            width: 53,
            textColor: '#FFFFFF',
            textSize: 14
          }
        ],
        mapOptions: {
          zoomControl: true,
          mapTypeControl: false,
          scaleControl: false,
          streetViewControl: false,
          rotateControl: false,
          fullscreenControl: false,
          disableDefaultUI: false,
        },
        infoWindow: {
          open: false,
          id: 0,
          title: '',
          website: '',
          address: '',
          phone: '',
          email: '',
          latitude: '',
          longitude: ''
        },
        mapBounds: {},
        reportedCenter: {}
	  }
    },

    mounted () {
      this.lat = parseFloat(this.latitude)
      this.long = parseFloat(this.longitude)
      this.placeMarkers()
      this.geolocate()
      loadGmapApi({
          key: this.maps_api_key,
          libraries: 'places'
        })
    },

    watch: {
      'latitude' () {
        this.lat = parseFloat(this.latitude)
        this.long = parseFloat(this.longitude)
        this.zoom = this.zoomdata
        this.placeMarkers()
        console.log('Marker should be changed.')
      }
    },

    methods: {
      fitBounds (bounds) {
        console.log(this.$refs.map)
        this.$refs.map.fitBounds(bounds);
      },

      truncate (input) {
        if (input.length > 18) {
          return input.substring(0, 18) + '...';
        }
        return input
      },

      placeMarkers () {
        console.log('place', this.lat)

        var bounds = new google.maps.LatLngBounds();

        $.each(this.locations, (key, value) => {

            this.markers.push({
              position: {
                lat: parseFloat(value.latitude),
                lng: parseFloat(value.longitude),
                id: value.id
              }
            })

            bounds.extend({
              lat: parseFloat(value.latitude),
              lng: parseFloat(value.longitude)
            })

        })

        // this.fitBounds(bounds)
      },

      openInfoWindow (id, key) {
        console.log(key)
        let store = this.locations.find(obj => obj.id === id)

        this.infoWindow.open = true
        this.infoWindow.id = store.id
        this.infoWindow.title = store.title
        this.infoWindow.website = store.website
        this.infoWindow.address = store.address
        this.infoWindow.phone = store.phone
        this.infoWindow.email = store.email
        this.infoWindow.latitude = store.latitude
        this.infoWindow.longitude = store.longitude

        this.selectedKey = key
      },

      closeInfoWindow () {
        this.infoWindow = {
          open: false,
          id: 0,
          name: '',
          website: '',
          address: '',
          latitude: '',
          longitude: '',
        }

        this.selectedKey = null
      },

      zoomChange () {
        console.log('dsa')
      },

      // dragEnd () {
      //   console.log('dragend', this.$refs.map)
      //   // this.$refs.map.getCenter()
      // },

      updateCenter (event) {
        console.log('center', event.lat)

        this.reportedCenter = {
          lat: event.lat(),
          lng: event.lng(),
        }

        this.$emit('draggedLatLong', this.reportedCenter)
      },

      geolocate () {
        this.$store.commit('setLoading', true)
        // this.lat = this.latitude
        // this.long = this.longitude
        // navigator.geolocation.getCurrentPosition(position => {
        //   this.lat = position.coords.latitude
        //   this.long = position.coords.longitude
        //   this.zoom = 4
        //   this.reportedCenter = {
        //     lat: position.coords.latitude,
        //     lng: position.coords.longitude
        //   }

        //   this.$store.commit('setLoading', false)
        //   this.$emit('draggedLatLong', this.reportedCenter)
        // })

      },

      getMarkers (key) {
        let icon = { url: '/images/marker.png', scaledSize: { width: 28, height: 36 }, labelOrigin: { x: 70, y: 20 } }
        let active = { url: '/images/marker.png', scaledSize: { width: 28, height: 36 }, labelOrigin: { x: 70, y: 20 } }
        if (this.selectedKey === key) return active
        return icon
      }
    }
  }
</script>

<style lang="scss">
@import "../../../sass/core/variables.scss";

.map-wrap {
  position: relative;
  width: 100%;
  height: 400px;

  @media (min-width: $medium) { height: 433px; }

  overflow: visible;

  .vue-map-container {
    width: 100%;
    height: 400px;

    font-size: 20px;

    @media (min-width: $medium) { height: 433px; }
  }

  &.hide { display: none; }

  .info-window {
    position: absolute;
    bottom: 40px;
    left: 7px;
    z-index: 999;

    display: flex;
    flex-flow: row wrap;
    justify-content: space-between;
    align-items: flex-start;

    width: 100%;
    max-width: 335px;
    padding: 16px;

    background: white;
    border-radius: 3px;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.2);

    @media (min-width: $medium) {
      bottom:20px;
      left: 20px;

      padding: 20px 30px;
    }

    .close-popup {
      position: absolute;
      top: 12px;
      right: 12px;

      width: 20px;
      height: 20px;
      margin: 0;
      padding: 0;

      cursor: pointer;

      .icon {
        font-size: 10px;
        font-weight: 700;
        line-height: 20px;
        color: $color-3;
      }
    }

    .text {
      display: inline-block;
      width: calc(100% - 108px);

      h4 {
        margin-bottom: 10px;

        font-family: $font-family-1;
        font-size: 12px;
        font-weight: 500;
        letter-spacing: 1px;
        line-height: 22px;
        text-transform: uppercase;
        color: #332e2b;
      }

      p, .address {
        margin: 0;

        font-size: 14px;
        font-weight: 400;
        line-height: 24px;

        &.orange {
          color: $color-3;
        }
      }

      .address {
        display: block;
        color: #4a4a4a;
      }

      a {
        margin: 0;

        font-size: 14px;
        font-weight: 400;
        line-height: 24px;
        color: $color-3;
      }
    }

    img {
      display: inline-block;
      vertical-align: top;
      width: 92px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// resources/assets/frontend/js/components/locations/Map.vue